import { render, staticRenderFns } from "./BancoImagenProductoModal.vue?vue&type=template&id=63f8efe7&"
import script from "./BancoImagenProductoModal.vue?vue&type=script&lang=js&"
export * from "./BancoImagenProductoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports